import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useSearchParams } from 'react-router-dom';

import { FilterButton } from './styles';
import Icon from '../../../Icon';
import newUseFilterParams from '../../../../hooks/newUseFilterParams';
import { FilterKeys } from '../../constants';
import type { FiltersListProps } from './types';
import { generateFilters } from './utils/generateFilters';
import { NEW_COLORS } from '../../../../themes/colors/newColors';

const NewFiltersList = ({ loadCompanyFilterList }: FiltersListProps) => {
  const { clearFilterName, clearMultipleFilterNames } = newUseFilterParams({});
  const [params] = useSearchParams();

  const loadCompanyFilterListMap = loadCompanyFilterList?.data?.pages ?? [];
  const fullFilters = generateFilters(params, loadCompanyFilterListMap);

  const clearFilter = (key: string) => {
    const isKeyDate = key === 'start-end-date';
    return isKeyDate
      ? clearMultipleFilterNames([FilterKeys.START_DATE, FilterKeys.END_DATE])
      : clearFilterName(key);
  };

  return (
    <Box gap={1} flexWrap="wrap" display="flex">
      {fullFilters.map(fullFilter => (
        <FilterButton key={fullFilter.value}>
          <Typography>{fullFilter.label}</Typography>
          <Icon
            onClick={e => {
              e.stopPropagation();
              clearFilter(fullFilter.key);
            }}
            name="actions-b2b-close"
            size={16}
            color={NEW_COLORS.BASE.WHITE}
          />
        </FilterButton>
      ))}
    </Box>
  );
};

export default NewFiltersList;
